/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from "vue-svgicon";
icon.register({
  door: {
    width: 38,
    height: 45,
    viewBox: "0 0 38 45",
    data:
      '<path fill="#fff" d="M18.8,0c-0.6,0-1.1,0.2-1.6,0.4L1.7,9.3C0.7,9.9,0,11,0,12.3v20.5c0,1.9,1.5,3.5,3.4,3.5V12.3h30.8v24.1c1.9,0,3.4-1.6,3.4-3.5V12.3c0-1.3-0.7-2.4-1.7-3L20.4,0.4C20,0.2,19.4,0,18.8,0z M6.8,15.8v5.3h10.3c0-1,0.8-1.8,1.7-1.8s1.7,0.8,1.7,1.8h10.3v-5.3H6.8z"/><path fill="#2e8bda" d="M18.8,45c4.7,0,8.6-3.9,8.6-8.7s-3.8-8.7-8.6-8.7s-8.6,3.9-8.6,8.7S14.1,45,18.8,45z"/><path fill="#fff" d="M14.8,35.5c1.4-2.1,3.6-4,3.7-4.1c0.1,0,0.1-0.1,0.3-0.1s0.2,0.1,0.4,0.1c0.1,0.1,2.3,2,3.7,4.1c0.1,0.1,0.1,0.4,0,0.6c-0.1,0.1-0.3,0.2-0.5,0.2h-1.9c0,0-0.2,4.4-0.4,4.6c-0.2,0.2-0.8,0.4-1.4,0.4c-0.5,0-1.1-0.2-1.3-0.4c-0.1-0.2-0.4-4.6-0.4-4.6h-1.9c-0.2,0-0.4-0.1-0.4-0.3C14.7,35.9,14.7,35.7,14.8,35.5z"/>',
  },
});
